import Upload from '@/screens/receptor/Upload.vue'
import Listagem from '@/screens/receptor/Listagem.vue'
import ListagemCadastrosPendentes from '@/screens/receptor/ListagemCadastrosPendentes.vue'
import MainPageModulo from '@/screens/receptor/MainPageModulo.vue'
import InformacoesCadastro from '@/components/InformacoesCadastro'
import HomeLiberacao from '@/screens/central/cadastros/maranhao/liberacao/Home'
import HomeProcessoFisico from '@/screens/central/cadastros/maranhao/processoFisico/Home'
import DetalhesProcesso from '@/screens/central/processos/DetalhesProcesso'
import Baixar from '@/screens/portal/publico/Baixar'
// import ListagemRetificacao from '@/screens/receptor/retificacao/Home'
import Retificacao from '@/screens/receptor/retificacao/Cadastro'

// LIBERACAO CLAUSULA RESOLUTIVA
import CadastranteLiberacaoClausula from '@/screens/central/cadastros/maranhao/liberacao/components/Cadastrante'
import InteressadoLiberacaoClausula from '@/screens/central/cadastros/maranhao/liberacao/components/Interessado'
import ImovelLiberacaoClausula from '@/screens/central/cadastros/maranhao/liberacao/components/Imovel'
import ResumoLiberacaoClausula from '@/screens/central/cadastros/maranhao/liberacao/components/Resumo'
import LiberacaoClausula from '@/screens/central/cadastros/maranhao/liberacao/Cadastro'
import EscolhaTipoProcesso from '@/screens/central/liberacao/EscolhaTipoProcesso'

// PROCESSO FISICO
import CadastranteProcessoFisico from '@/screens/central/cadastros/maranhao/processoFisico/components/Cadastrante'
import InteressadoProcessoFisico from '@/screens/central/cadastros/maranhao/processoFisico/components/Interessado'
import ImovelProcessoFisico from '@/screens/central/cadastros/maranhao/processoFisico/components/Imovel'
import ResumoProcessoFisico from '@/screens/central/cadastros/maranhao/processoFisico/components/Resumo'
import ProcessoFisico from '@/screens/central/cadastros/maranhao/processoFisico/Cadastro'
import EscolhaTipoProcessoFisico from '@/screens/central/processoFisico/EscolhaTipoProcessoFisico'

// RETIFICACAO
import QualificacaoRetificacao from '@/screens/central/cadastros/para/retificacao/components/Qualificacao'
import DestinacaoUsoImovel from '@/screens/central/cadastros/para/retificacao/components/DestinacaoUsoImovel'
import CadastranteRetificacao from '@/screens/central/cadastros/para/retificacao/components/Cadastrante'
import InteressadoRetificacao from '@/screens/central/cadastros/para/retificacao/components/Interessado'
import ImovelRetificacao from '@/screens/central/cadastros/para/retificacao/components/Imovel'
import ResumoRetificacao from '@/screens/central/cadastros/para/retificacao/components/Resumo'
import GeorreferenciamentoRetificacao from '@/screens/central/cadastros/para/retificacao/components/GeorreferenciamentoRetificacao'

import PERFIL from '@/constants/perfil'

const setRouteGroup = group => {
  return { routeGroup: group }
}

const setParentRouteGroup = group => {
  return { parentRouteGroup: group }
}

const receptor = [
  {
    path: '/receptor',
    name: 'receptor',
    component: MainPageModulo,
    children: [
      {
        path: '/receptor/upload',
        name: 'receptor/upload',
        component: Upload,
        meta: {
          isPublic: false,
          routeGroup: 'UPLOAD'
        }
      },
      {
        path: '/receptor/listagem',
        name: 'receptor/listagem',
        component: Listagem,
        meta: {
          isPublic: false,
          menu: 'receptor/listagem',
          perfis: [PERFIL.RECEPTOR.RECEPTOR.codigo, PERFIL.RECEPTOR.RECEPTOR_EXTERNO.codigo],
          ...setRouteGroup('RECEPTOR_INFO_CADASTRO')
        }
      },
      {
        path: '/receptor/listagem-cadastros-pendentes',
        name: 'receptor/listagem-cadastros-pendentes',
        component: ListagemCadastrosPendentes,
        meta: {
          isPublic: false,
          menu: 'receptor/listagem-cadastros-pendentes',
          perfis: [PERFIL.RECEPTOR.RECEPTOR.codigo, PERFIL.RECEPTOR.RECEPTOR_EXTERNO.codigo],
          ...setRouteGroup('RECEPTOR_INFO_CADASTRO_PENDENTE')
        }
      },
      {
        path: '/receptor/download',
        name: 'receptor/download',
        component: Baixar,
        meta: {
          isPublic: false,
          routeGroup: 'DOWNLOAD'
        }
      },
      {
        path: 'liberacao-clausula',
        name: 'receptor/liberacao-clausula',
        component: HomeLiberacao,
        meta: {
          isPublic: false,
          menu: 'receptor/liberacao-clausula',
          perfis: [PERFIL.RECEPTOR.RECEPTOR.codigo, PERFIL.RECEPTOR.RECEPTOR_EXTERNO.codigo],
          ...setRouteGroup('LIBERACAO_CLAUSULA')
        }
      },
      {
        path: 'cadastro/escolher-tipo-processo',
        name: 'receptor/cadastro/escolher-tipo-processo',
        component: EscolhaTipoProcesso,
        meta: {
          menu: 'receptor/liberacao-clausula',
          perfis: [PERFIL.RECEPTOR.RECEPTOR.codigo, PERFIL.RECEPTOR.RECEPTOR_EXTERNO.codigo],
          ...setRouteGroup('LIBERACAO_CLAUSULA')
        }
      },
      {
        path: 'listagem/detalhes-processo-receptor/:idCadastro/:id',
        name: 'detalhes-processo-receptor',
        component: DetalhesProcesso,
        props: true,
        redirect: { name: 'informacoesCadastroReceptor' },
        children: [
          {
            path: 'informacoesCadastroReceptor',
            name: 'informacoesCadastroReceptor',
            component: InformacoesCadastro,
            meta: {
              perfis: [PERFIL.RECEPTOR.RECEPTOR.codigo, PERFIL.RECEPTOR.RECEPTOR_EXTERNO.codigo],
              ...setRouteGroup('RECEPTOR_INFO_CADASTRO'),
              ...setParentRouteGroup('LISTAGEM'),
              isSubMenu: true
            }
          }
        ]
      },
      {
        path: 'listagem/detalhes-cadatro-pendente-receptor/:idCadastro/:id',
        name: 'detalhes-cadatro-pendente-receptor',
        component: DetalhesProcesso,
        props: (route) => ({
          idCadastro: route.params.idCadastro,
          id: route.params.id,
          isCadastroPendente: true
        }),
        redirect: { name: 'informacoesCadastroPendente' },
        children: [
          {
            path: 'informacoesCadastroPendente',
            name: 'informacoesCadastroPendente',
            component: InformacoesCadastro,
            meta: {
              perfis: [PERFIL.RECEPTOR.RECEPTOR.codigo, PERFIL.RECEPTOR.RECEPTOR_EXTERNO.codigo],
              ...setRouteGroup('RECEPTOR_INFO_CADASTRO_PENDENTE'),
              ...setParentRouteGroup('LISTAGEM_CADASTROS_PENDENTES'),
              isSubMenu: true
            }
          }
        ]
      },
      {
        path: 'liberacao-clausula/:idCadastro',
        name: 'receptor/liberacao-clausula',
        component: LiberacaoClausula,
        props: true,
        redirect: { name: 'liberacao-clausula/cadastrante' },
        children: [
          {
            path: 'cadastrante',
            name: 'receptor/liberacao-clausula/cadastrante',
            component: CadastranteLiberacaoClausula,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('LIBERACAO_CLAUSULA')
            }
          },
          {
            path: 'interessado',
            name: 'receptor/liberacao-clausula/interessado',
            component: InteressadoLiberacaoClausula,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('LIBERACAO_CLAUSULA')
            }
          },
          {
            path: 'imovel',
            name: 'receptor/liberacao-clausula/imovel',
            component: ImovelLiberacaoClausula,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('LIBERACAO_CLAUSULA')
            }
          },
          {
            path: 'resumo',
            name: 'receptor/liberacao-clausula/resumo',
            component: ResumoLiberacaoClausula,
            meta: {
              // Deve ser usado para casos de páginas do cadastro que não devem ser um das abas
              isResumo: true,
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('LIBERACAO_CLAUSULA')
            }
          }
        ]
      },
      {
        path: 'processo-fisico',
        name: 'receptor/processo-fisico',
        component: HomeProcessoFisico,
        meta: {
          isPublic: false,
          menu: 'receptor/processo-fisico',
          perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
          ...setRouteGroup('PROCESSO_FISICO')
        }
      },
      {
        path: 'cadastro/escolher-tipo-processo-fisico',
        name: 'receptor/cadastro/escolher-tipo-processo-fisico',
        component: EscolhaTipoProcessoFisico,
        meta: {
          menu: 'receptor/processo-fisico',
          perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
          ...setRouteGroup('PROCESSO_FISICO')
        }
      },
      {
        path: 'processo-fisico/:idCadastro',
        name: 'receptor/processo-fisico',
        component: ProcessoFisico,
        props: true,
        redirect: { name: 'processo-fisico/cadastrante' },
        children: [
          {
            path: 'cadastrante',
            name: 'receptor/processo-fisico/cadastrante',
            component: CadastranteProcessoFisico,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('PROCESSO_FISICO')
            }
          },
          {
            path: 'interessado',
            name: 'receptor/processo-fisico/interessado',
            component: InteressadoProcessoFisico,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('PROCESSO_FISICO')
            }
          },
          {
            path: 'imovel',
            name: 'receptor/processo-fisico/imovel',
            component: ImovelProcessoFisico,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('PROCESSO_FISICO')
            }
          },
          {
            path: 'resumo',
            name: 'receptor/processo-fisico/resumo',
            component: ResumoProcessoFisico,
            meta: {
              isResumo: true,
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('PROCESSO_FISICO')
            }
          }
        ]
      },
      {
        path: '/receptor/cadastro/retificacao/new',
        name: 'cadastro/retificacao/new',
        component: Retificacao,
        props: true,
        redirect: { name: 'retificacao/qualificacao' }
      },
      {
        path: '/receptor/cadastro/retificacao/:id',
        name: 'receptor/cadastro/retificacao',
        component: Retificacao,
        props: true,
        redirect: { name: '/receptor/retificacao/cadastrante' },
        children: [
          {
            path: '/receptor/qualificacao',
            name: 'retificacao/qualificacao',
            component: QualificacaoRetificacao,
            meta: {
              // Deve ser usado para casos de páginas do cadastro que não devem ser um das abas
              isIntro: true,
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('PROCESSO_FISICO')
            }
          },
          {
            path: 'cadastrante',
            name: 'receptor/retificacao/cadastrante',
            component: CadastranteRetificacao,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('PROCESSO_FISICO')
            }
          },
          {
            path: 'interessado',
            name: 'receptor/retificacao/interessado',
            component: InteressadoRetificacao,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('PROCESSO_FISICO')
            }
          },
          {
            path: 'imovel',
            name: 'receptor/retificacao/imovel',
            component: ImovelRetificacao,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('PROCESSO_FISICO')
            }
          },
          {
            path: 'destinacaoUsoImovel',
            name: 'receptor/retificacao/destinacaoUsoImovel',
            component: DestinacaoUsoImovel,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('PROCESSO_FISICO')
            }
          },
          {
            path: 'georreferenciamento',
            name: 'receptor/retificacao/georreferenciamento',
            component: GeorreferenciamentoRetificacao,
            meta: {
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('PROCESSO_FISICO')
            }
          },
          {
            path: 'resumo',
            name: 'receptor/retificacao/resumo',
            component: ResumoRetificacao,
            meta: {
              isResumo: true,
              perfis: PERFIL.RECEPTOR.RECEPTOR.codigo,
              ...setRouteGroup('CENTRAL_RETIFICACAO')
            }
          }
        ]
      }
    ]
  }
]

export default receptor



// WEBPACK FOOTER //
// ./src/router/receptor.js